exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-toggler{position:relative;display:flex;flex-direction:column}adp-toggler toggle-content,adp-toggler toggle-item{display:block}adp-toggler.to-right .toggle-content{right:auto;left:0}adp-toggler.to-left .toggle-content{right:0;left:auto}adp-toggler .toggler{position:relative;cursor:pointer}adp-toggler .toggle-content{position:absolute;min-width:100%;top:100%;right:0;z-index:50;opacity:0;visibility:hidden;transform:translateY(-15px)}adp-toggler .toggle-content,adp-toggler .toggle-content.opened{transition:opacity .3s ease,visibility .3s ease,transform .3s ease}adp-toggler .toggle-content.opened{opacity:1;visibility:visible;transform:translateY(6px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpToggler/adpToggler.less
// module id = 486
// module chunks = 0